import React from "react";
import "./Help.css";
import reachus from "../../assets/reachus.jpg";
import faqImg from "../../assets/facilities/FAQ.jpg";
import purchaseproductquery from "../../assets/purchaseproductquery.jpg"
import Footer from "../Footer/Footer";
import { useNavigate } from "react-router-dom";


const Help = () => {
    const navigate = useNavigate();
    return (
        <div className="help-container">
            <section className="help-banner">
                <img src={reachus} alt="Help Banner" />
                {/* <div className="help-banner-toptext">Help</div> */}

                {/* <div className="help-banner-text">
                    We offer premium support and efficient solutions                                   .
                </div> */}
            </section>
            {/* FAQ Section */}
            <section className="faq-section">
                <div className="faq-container">
                    <div className="faq-left">
                        <img src={faqImg} alt="FAQ" className="faq-image" />
                    </div>
                    <div className="faq-right">
                        <h2 className="faq-title">FAQ’s</h2>
                        <p className="faq-description">
                            We have summarized the FAQs based on discussion with our esteemed clients to help you get details
                            readily available about our offering. If you have any specific queries about our products or services
                            kindly help us to receive your e-mail to <a href="mailto:bd@varanouslabs.com">bd@varanouslabs.com</a>. We request you to include
                            your contact details in your e-mail so we can reach to you.
                        </p>
                        <button
                            className="faq-button"
                            onClick={() => navigate("/faqs")}
                        >
                         Click Me
                        </button>

                    </div>
                </div>
            </section>
            <section className="query-section">
  <div className="query-container">
    <div className="query-left">
      <h2 className="query-title">Purchase Product Query</h2>
      <p className="query-description">
        Varanous is aware of importance of time-line completing your project on-time. If you are facing any issue handling procured product, you can raise the query in few simple steps after registering with us. Post registration you will need a PO No to register a query. We will respond to your query in 24 h with further action.
      </p>
      <button className="query-button" onClick={() => navigate("/Products")}>

       Click Me
      </button>
    </div>
    <div className="query-right">
      <img src={purchaseproductquery} alt="Purchase Product Query" className="query-image" />
    </div>
  </div>
</section>
<section className="reachus-section">
  <div className="reachus-container">
    <div className="reachus-left">
      <img
        src={require("../../assets/reachus.jpg")}
        alt="Reach Us"
        className="reachus-image"
      />
    </div>
    <div className="reachus-right">
      <div className="reachus-text">
        <h2 className="reachus-title">Reach Us</h2>
        <p className="reachus-description">
          To get prompt response from us regarding any of your prospective requirement, intended purchase or procured product, we request you to send e-mail to concern department. We recommend to keep cc to <a href="mailto:bd@varanouslabs.com">bd@varanouslabs.com</a> always to get prompt response.
        </p>
        <button className="reachus-button" onClick={() => window.location.href = "/contact"}>
         Click Me
        </button>
      </div>
    </div>
  </div>
</section>


            <Footer />
        </div>
    );
};

export default Help;
